import styled from "styled-components";

export const TableItemStyle = styled.tr`
  .disabled {
    pointer-events: none;
    background-color: #ab92bf;
    color: white;
    border: transparent;
  }
`;

export const Form = styled.form`
  flex-wrap: wrap;
  .select-search {
    width: 135px;
    .field-holder .input {
      width: 135px !important;
    }
  }

  .input-type {
    width: 200px;
    .field-holder .input {
      width: 200px !important;
    }
  }

  .select-search-submit-types.client {
    width: 140px;
    .react-select {
      width: 140px;
    }
  }

  .dates {
    width: 250px !important;
  }
`;
